import axios from "axios";
import { HOST_API_KEY } from "../../config";
import { axiosInstanceWithToken } from "../utils/axios";

const SEO_REQUEST_TIMEOUT_MS = 800;
const PROFILE_REQUEST_TIMEOUT_MS = 10000;
const USER_DETAILS_REQUEST_TIMEOUT_MS = 2500;

export const getUsers = async () => {
  const request = await axios.get(`${HOST_API_KEY}/users`);
  return request?.data;
};

export const getUserById = async (id) => {
  try {
    const request = await axios.get(`${HOST_API_KEY}/user/${id}`, {
      timeout: USER_DETAILS_REQUEST_TIMEOUT_MS,
    });
    if (request?.data) return request.data;
  } catch {}

  const fallbackRequest = await axiosInstanceWithToken.get(
    `${HOST_API_KEY}/user-profile-for-display/${id}`,
    {
      params: { page: 1 },
      timeout: PROFILE_REQUEST_TIMEOUT_MS,
    }
  );
  return fallbackRequest?.data;
};

export const getUserDataByUserId = async (userId, params) => {
  const request = await axiosInstanceWithToken.get(
    `${HOST_API_KEY}/user-profile-for-display/${userId}`,
    {
      params,
      timeout: PROFILE_REQUEST_TIMEOUT_MS,
    }
  );
  return request?.data;
};

export const getUserLastIpByUserId = async (userId) => {
  const request = await axios.get(`${HOST_API_KEY}/user-last-ip/${userId}`);
  return request?.data;
};

export const getUserStatsByUserId = async (userId) => {
  const request = await axios.get(`${HOST_API_KEY}/user-stats/${userId}`);
  return request?.data;
};

export const getUserDetailsForTooltip = async (params) => {
  const request = await axios.get(`${HOST_API_KEY}/user-details-for-tooltip/`, {
    params,
  });
  return request?.data;
};

export const getSeoDetailsForUsersPage = async (params) => {
  const request = await axios.get(`${HOST_API_KEY}/users-page-seo-details`, {
    params,
    timeout: SEO_REQUEST_TIMEOUT_MS,
  });
  return request?.data;
};

export const getUserAnalytics = async (period) => {
  const request = await axios.get(`${HOST_API_KEY}/user-analytics/${period}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("jwtToken")}`,
    },
  });
  return request?.data;
};
